import React, { useMemo } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaGlobe,
} from "react-icons/fa6";

const iconMap = {
  "fa-facebook": FaFacebookF,
  "fa-twitter": FaTwitter,
  "fa-youtube": FaYoutube,
  "fa-instagram": FaInstagram,
  "fa-linkedin": FaLinkedinIn,
  "fa-globe": FaGlobe,
};

const HinduTodayFooter = ({ data }) => {
  const year = data?.copyright?.year || new Date().getFullYear();
  const copyrightText =
    data?.copyright?.text || `© ${year} The Hindu Today. All Rights Reserved`;

  const sections = useMemo(() => {
    const company = data?.company;
    const policies = data?.policies;

    return [
      company?.links?.length ? company : null,
      policies?.links?.length ? policies : null,
    ].filter(Boolean);
  }, [data]);

  const socials = data?.social_media?.links || [];

return (
  <footer className="mt-10 border-t border-gray-200 bg-white select-none">
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6">

      {/* MAIN ROW */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">

        {/* LEFT SIDE - Company + Policies */}
        <div className="flex flex-wrap items-start gap-6 md:gap-12">

          {sections.map((sec) => (
            <div key={sec.title}>
              <p className="text-sm font-semibold text-[#871b20] mb-2">
                {sec.title}
              </p>

              <div className="flex flex-wrap gap-x-4 gap-y-1">
                {sec.links.map((l, i) => (
                  <a
                    key={`${l.label}-${i}`}
                    href={l.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm text-gray-600 hover:text-orange-700 transition"
                  >
                    {l.label}
                  </a>
                ))}
              </div>
            </div>
          ))}

        </div>

        {/* RIGHT SIDE - Social */}
        {socials?.length > 0 && (
          <div className="flex items-center gap-3">
            {socials.map((s, idx) => {
              const Icon = iconMap[s.icon] || FaGlobe;
              return (
                <a
                  key={`${s.icon}-${idx}`}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-full border border-gray-200
                    text-gray-600
                    hover:border-orange-300 hover:text-orange-700
                    transition
                  "
                >
                  <Icon className="text-[14px]" />
                </a>
              );
            })}
          </div>
        )}

      </div>

      {/* BOTTOM COPYRIGHT */}
      <div className="mt-6 border-t border-gray-200 pt-4 text-sm text-gray-600 flex justify-between">
        <span>{copyrightText}</span>

        {data?.company?.links?.some((x) => x.label === "Sitemap") && (
          <a
            href={data?.company?.links?.find((x) => x.label === "Sitemap")?.url}
            target="_blank"
            rel="noreferrer"
            className="hover:text-orange-700 transition"
          >
            Sitemap
          </a>
        )}
      </div>

    </div>
  </footer>
);

};

export default HinduTodayFooter;
